import { Dispatch } from "react";
import { Action } from "redux";
import { ReportListSlice } from "./reducer";
import { ColdexAPI } from "../../../apis/apiColdex/ColdexAPI";
import { IApiResult } from "../../../utils/interfaces/store/IApiResponse";
import { ConfigReport } from "../../../utils/types/ConfigReport";
import { RoleConfigReport } from "../../../utils/types/RoleConfigReport";

export const ReportListEffect = {
  clean: () => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ReportListSlice.actions.clean());
    };
  },
  getConfigReports: () => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ReportListSlice.actions.getConfigReports());

      ColdexAPI.get<IApiResult<ConfigReport[]>>(`benchreports/config-reports`)
        .then(({ data }) => {
          if (data.dataError) {
            dispatch(
              ReportListSlice.actions.getConfigReportsError({
                iserror: true,
                shorterror: data.shortMessage,
                error: data.resultMessage,
              })
            );
            return;
          }

          dispatch(
            ReportListSlice.actions.getConfigReportsSuccess(data.resultObject)
          );
        })
        .catch((error) => {
          dispatch(
            ReportListSlice.actions.getConfigReportsError({
              iserror: true,
              shorterror: `Error short`,
              error,
            })
          );
        });
    };
  },
  getConfigReportsSelected: (roleId: number) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ReportListSlice.actions.getConfigReportsSelected());

      ColdexAPI.get<IApiResult<RoleConfigReport[]>>(
        `benchreports/roles/${roleId}/config-reports`
      )
        .then(({ data }) => {
          if (data.dataError) {
            dispatch(
              ReportListSlice.actions.getConfigReportsSelectedError({
                iserror: true,
                shorterror: data.shortMessage,
                error: data.resultMessage,
              })
            );
            return;
          }

          dispatch(
            ReportListSlice.actions.getConfigReportsSelectedSuccess(
              data.resultObject.map(({ configReport }) => configReport)
            )
          );
        })
        .catch((error) => {
          dispatch(
            ReportListSlice.actions.getConfigReportsSelectedError({
              iserror: true,
              shorterror: `Error short`,
              error,
            })
          );
        });
    };
  },
};
